<script setup lang="ts">
definePageMeta({
  layout: 'default',
})

</script>
<template>
  <div class="pt-10 pb-24 sm:pb-32 lg:py-24">
    <UtilsBookingView />
  </div>
</template>